import React, { useState } from 'react';
import AlertTriangle from 'lucide-react/dist/esm/icons/alert-triangle.js';
import TestTube from 'lucide-react/dist/esm/icons/test-tube.js';
import X from 'lucide-react/dist/esm/icons/x.js';
import { useSiteConfig } from '../contexts/SiteConfigContext';
import { useTranslations } from '../contexts/TranslationContext';

const DISMISSED_KEY = 'sandbox_banner_dismissed';

export default function SandboxBanner() {
  const { siteDetails } = useSiteConfig();
  const { t } = useTranslations();
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem(DISMISSED_KEY) === '1'; } catch { return false; }
  });

  // API returns isSandBox (camelCase) from site details endpoint
  if (!siteDetails?.isSandBox || dismissed) {
    return null;
  }

  const handleDismiss = () => {
    setDismissed(true);
    try { localStorage.setItem(DISMISSED_KEY, '1'); } catch { /* noop */ }
  };

  return (
    <div className="bg-gradient-to-r from-amber-500 to-orange-500 text-white text-sm text-center py-2.5 px-4 flex items-center justify-center gap-2 shadow-md relative z-[60]">
      <TestTube className="w-4 h-4 flex-shrink-0 animate-pulse" />
      <span className="font-semibold">{t('sandbox.mode')}</span>
      <span className="hidden sm:inline text-white/90 mx-2">|</span>
      <span className="hidden sm:inline text-white/90 text-xs">{t('sandbox.testEnvironment')}</span>
      <AlertTriangle className="w-4 h-4 flex-shrink-0 ml-2 hidden sm:block" />
      <button
        onClick={handleDismiss}
        className="ml-3 p-0.5 rounded hover:bg-white/20 transition-colors"
        aria-label="Dismiss sandbox banner"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
